import { store, getElement, getContext } from '@wordpress/interactivity';

const { state } = store('mediapress-listicle', {
  state: {
    get shouldShowItem() {
      const { visibleItems, isReversed } = state;

      if (visibleItems === -1) return true;

      const { index } = getContext();

      if (isReversed) {
        return index > visibleItems;
      }

      return index <= visibleItems;
    },
    get contentVisibility() {
      const { shouldShowItem } = state;

      return shouldShowItem ? 'visible' : 'hidden';
    },
  },
  callbacks: {
    observe: () => {
      if (!state.observer) return;

      const element = getElement().ref;

      state.observer.observe(element);
    },
  },
});
